// Dynamic import based on language
let taxonomyTree;

// Function to detect current language
function getCurrentLanguage() {
  // Check document language first
  if (document.documentElement.lang) {
    return document.documentElement.lang.toLowerCase();
  }
  
  // Check URL pattern for Spanish
  if (window.location.pathname.startsWith('/es/')) {
    return 'es';
  }
  
  // Default to English
  return 'en';
}

// Load appropriate taxonomy
async function loadTaxonomy() {
  const currentLang = getCurrentLanguage();
  
  if (currentLang === 'es') {
    const module = await import('./taxonomy-data-es.js');
    taxonomyTree = module.taxonomyTree;
  } else {
    const module = await import('./taxonomy-data.js');
    taxonomyTree = module.taxonomyTree;
  }
}

class CategoryNavigation {
  constructor() {
    this.taxonomyData = taxonomyTree;
    this.currentPath = [];
    this.initialize();
  }

  initialize() {
    // Get current collection handle from URL
    const pathParts = window.location.pathname.split('/');
    const collectionIndex = pathParts.indexOf('collections');
    if (collectionIndex !== -1 && pathParts.length > collectionIndex + 1) {
      this.currentCollectionHandle = pathParts[collectionIndex + 1];
      this.determineCurrentPath();
      this.updateBreadcrumbs();
    }
  }

  determineCurrentPath() {
    const findPath = (tree, target, currentPath = []) => {
      for (const [key, value] of Object.entries(tree)) {
        const handle = this.toHandle(key);
        if (handle === target) {
          this.currentPath = [...currentPath, key];
          return true;
        }
        if (value && typeof value === 'object') {
          if (findPath(value, target, [...currentPath, key])) {
            return true;
          }
        }
      }
      return false;
    };

    findPath(this.taxonomyData, this.currentCollectionHandle);
  }

  toHandle(str) {
    return str.toLowerCase()
      .replace(/&/g, 'and')
      .replace(/['"'']/g, '')
      .replace(/[\(\)]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .replace(/,/g, '');
  }

  getLevel() {
    return this.currentPath.length;
  }

  getCurrentSubcategories() {
    let current = this.taxonomyData;
    for (const path of this.currentPath) {
      current = current[path];
    }
    return current ? Object.keys(current).filter(key => current[key] !== null) : [];
  }

  updateBreadcrumbs() {
    const breadcrumbContainer = document.querySelector('.breadcrumb-nav');
    if (!breadcrumbContainer) return;

    const currentLang = getCurrentLanguage();
    const urlPrefix = currentLang === 'es' ? '/es' : '';

    const breadcrumbs = this.currentPath.map((category, index) => {
      let path = `${urlPrefix}/collections/`;
      path += this.toHandle(this.currentPath.slice(0, index + 1).join('-'));
      return `
        <a href="${path}" class="breadcrumb-link">${category}</a>
        ${index === this.currentPath.length - 1 ? `
          <a href="${urlPrefix}/collections" class="breadcrumb-close" aria-label="Close category and return to all collections">×</a>
        ` : ''}
      `;
    });

    breadcrumbContainer.innerHTML = `
      <a href="${urlPrefix}/collections" class="breadcrumb-link">All Collections</a>
      ${breadcrumbs.length > 0 ? ' / ' + breadcrumbs.join(' / ') : ''}
    `;

    // Add click handler for close button
    const closeButton = breadcrumbContainer.querySelector('.breadcrumb-close');
    if (closeButton) {
      closeButton.addEventListener('click', (e) => {
        e.preventDefault();
        window.location.href = `${urlPrefix}/collections`;
      });
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', async () => {
  await loadTaxonomy();
  window.categoryNavigation = new CategoryNavigation();
}); 